import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'checkbox-specs',
  templateUrl: './checkbox-specs.component.html',
  styleUrls: ['./checkbox-specs.component.sass']
})
export class CheckboxSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/checkbox/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
